import fs from 'node:fs'
import path from 'node:path'

export function hasDbUrl(cwd: string): boolean {
  const envPath = path.join(cwd, '.env.local')
  if (!fs.existsSync(envPath)) return false
  const content = fs.readFileSync(envPath, 'utf-8')
  for (const line of content.split('\n')) {
    const trimmed = line.trim()
    if (trimmed.startsWith('#') || !trimmed.includes('=')) continue
    const [key, ...rest] = trimmed.split('=')
    if (key?.trim() === 'DATABASE_URL') {
      const val = rest.join('=').trim()
      const unquoted = val.replace(/^['"]|['"]$/g, '')
      return unquoted.length > 0 && !unquoted.startsWith('your_') && unquoted !== 'postgresql://...'
    }
  }
  return false
}
